import { Entity } from './Entity';

/**
 * Base Component class for the engine's ECS architecture.
 * All components must extend this class.
 */
export abstract class Component {
  protected entity: Entity | null = null;

  /**
   * Set the entity that owns this component
   */
  public setEntity(entity: Entity): void {
    this.entity = entity;
  }

  /**
   * Get the entity that owns this component
   */
  public getEntity(): Entity | null {
    return this.entity;
  }

  /**
   * Clone this component (used for prefabs/templates)
   */
  public abstract clone(): Component;
}
